import { fetchChannelDataRows } from "../../utilities/apiRequests";
/**
 * Fetches all city coordinates from the CityCoordinates.json file.
 * @returns {Promise<Array>} A promise that resolves to an array of city coordinates.
 */
export async function fetchCityCoordinates() {
    try {
        const response = await fetch("/data/CityCoordinates.json");
        if (!response.ok) {
            throw new Error(`Failed to fetch city coordinates: ${response.statusText}`);
        }
        const cityCoordinates = await response.json();
        return cityCoordinates;
    } catch (error) {
        console.error("Error fetching city coordinates:", error);
        return [];
    }
}

/**
 * Fetches all channel data from the API.
 * @param {} accessToken - access token with authorizationParams: { scope: "read:channels" } }
 * @returns {Promise<Array>} A promise that resolves to an array of channel data.
 */
export async function fetchAllChannelData(accessToken) {
    try {
        const fields = ["call_sign", "market", "affiliation", "channel_id", "atsc1_vp1_deployed", "website_vod_assets"]; //later add "devices", "avg_viewer" and more
        const channelData = await fetchChannelDataRows(accessToken, fields);
        return channelData;
    } catch (error) {
        console.error("Error fetching channel data:", error);
        return [];
    
    }
}

export function ATSC3(){
    return [
        'Albany-Schenectady-Troy, NY',
        'Albuquerque-Santa Fe, NM',
        'Atlanta, GA',
        'Austin, TX',
        'Baltimore, MD',
        'Baton Rouge, LA',
        'Birmingham (Anniston and Tuscaloosa), AL',
        'Boston, MA',
        'Buffalo, NY',
        'Champaign-Springfield-Decatur, IL',
        'Charleston-Huntington, WV',
        'Charleston, SC',
        'Charlotte, NC',
        'Chattanooga, TN',
        'Chicago, IL',
        'Cincinnati, OH',
        'Cleveland-Akron, OH',
        'Columbus, OH',
        'Dallas-Fort Worth, TX',
        'Davenport,IA',
        'Dayton, OH',
        'Denver, CO',
        'Des Moines, IA',
        'Detroit, MI',
        'El Paso, TX',
        'Flint-Saginaw-Bay City, MI',
        'Fresno-Visalia, CA',
        'Grand Rapids-Kalamazoo, MI',
        'Green Bay-Appleton, WI',
        'Greensboro-Winston-Salem-High Point, NC',

        'Greenville-New Bern-Washington, NC',
        'Greenville-Spartanburg-Anderson, SC Asheville, NC',
        'Harrisburg, PA',
        'Hartford-New Haven, CT',
        'Honolulu, HI',
        'Houston, TX',
        'Indianapolis, IN',
        'Jacksonville, FL',
        'Kansas City, KS-MO',
        'Lansing, MI',
        'Las Vegas, NV',
        'Little Rock-Pine Bluff, AR',
        'Los Angeles, CA',
        'Louisville, KY',
        'Memphis, TN',
        'Miami-Ft. Lauderdale, FL',
        'Milwaukee, WI',
        'Minneapolis-St. Paul, MN',
        'Myrtle Beach, SC',
        'Mobile, AL-Pensacola, FL',
        'Nashville, TN',
        'New Orleans, LA',
        'New York, NY',
        'Norfolk-Portsmouth-Newport News, VA',
        'Oklahoma City, OK',
        'Omaha, NE',
        'Orlando-Daytona Beach-Melbourne, FL',
        'Philadelphia, PA',
        'Phoenix, AZ',
        'Pittsburgh, PA',

        'Portland, OR',
        'Portland-Auburn, ME',
        'Providence, RI-New Bedford, MA',
        'Raleigh-Durham, NC',
        'Reno, NV',
        'Richmond, VA',
        'Roanoke,VA',
        'Rochester, NY',
        'Sacramento-Stockton-Modesto, CA',
        'Salt Lake City, UT',
        'San Antonio, TX',
        'San Diego, CA',
        'San Francisco-Oakland-San Jose, CA',
        'Santa Barbara-Santa Marie-San Luis Obispo, CA',
        'Seattle-Tacoma, WA',
        'Shreveport, LA',
        'South Bend, IN',
        'Springfield-Holyoke, MA',
        'Springfield, MO',
        'St. Louis, MO',
        'Syracuse, NY',
        'Tallahassee, FL',
        'Tampa-St.Petersburg-Sarasota, FL',
        'Tucson, AZ',
        'Tulsa, OK',
        'Washington, D.C.',
        'West Palm Beach-Ft. Pierce, FL',
        'Wichita-Hutchinson Plus, KS',
        'Wilkes Barre-Scranton-Hazelton, PA',
    ]
} 

export function ATSC1(){
    return []
}